import React, { useRef } from "react";
import ListCalendar from "./ListCalendar";
import ReservationList from "./ReservationList";
import { Macros } from "../models/Macros";
import { useAppContext } from "../contexts/AppContext";
import { TListCalendarWrapperProps } from "../types/components/ListCalendarWrapper";

type TReservationListCalendarProps = {
    id: number;
    onInfoOpen: (entryIds: number[], showPanel?: boolean) => void;
} & TListCalendarWrapperProps;

const getRefreshEvents = () => [
    Macros.Event.SELECT_RESERVATION,
    Macros.Event.RESERVATION_MADE_OR_MODIFIED,
    Macros.Event.RESERVATION_RESTORED,
];

const ReservationListCalendar = (props: TReservationListCalendarProps) => {
    const appContext = useAppContext();
    const wrapper = useRef<any>(null);

    const onSelection = (selection) => {
        if (!selection.cancelled) {
            appContext.fireEvent(
                `reservationList${props.id}`,
                Macros.Event.SELECT_RESERVATION,
                selection
            );
            props.onInfoOpen([selection.id], false);
        }
    };

    return (
        <ListCalendar
            {...props}
            type={"reservationList"}
            refreshEvents={getRefreshEvents()}
            onSelection={onSelection}
            listRef={(node) => {
                wrapper.current = node;
            }}
        >
            <ReservationList />
        </ListCalendar>
    );
};

export default ReservationListCalendar;
